import { render } from "./MyTracker.vue?vue&type=template&id=d3c8bc5e"
import script from "./MyTracker.vue?vue&type=script&lang=js"
export * from "./MyTracker.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__